import React from 'react';
import pic from '../images/chobi.jpg';
import facebook from '../images/facebook.jpg'
import github from '../images/github.png'
import linkdin from '../images/linkdin.webp'

import './AboutMe.css';
const AboutMe = () => {
    return (
        <div style={{ backgroundColor: '#0E0C0A', color: 'white' }}>
            <h4 className="pt-5" style={{ marginLeft: '100px', color: 'white' }}>About me</h4>
            <p style={{ marginLeft: '100px' }}>Welcome, Learn me more.</p>
            <div class="row mt-5 ">
                <div class="col-lg-4">
                    <div className="row ">
                        <img src={pic} class="img-fluid rounded-circle w-75" alt="" />
                    </div>
                    <div style={{ marginLeft: '100px' }} className="row mt-3 p-3">
                        <ul class="social-network social-circle">
                            <li><a target="_blank" href="https://www.facebook.com/profile.php?id=100009462221193" class="icoFacebook" title="Facebook">
                                <img style={{ height: '30px' }} src={facebook} alt="" />

                                <i class="fa fa-facebook"></i></a></li>
                            <li><a target="_blank" href="https://www.linkedin.com/in/shatabdi-esh-chowdhury-b1b0a6241/" class="icoLinkedin" title="Linkedin"><i class="fa fa-linkedin"></i>
                                <img style={{ height: '30px' }} src={linkdin} alt="" />

                            </a></li>
                            <li><a target="_blank" href="https://github.com/Eshshatabdi" class="icoGitHub" title="GitHub">

                                <img style={{ height: '30px' }} src={github} alt="" />

                            </a></li>

                        </ul>
                    </div>

                </div>
                <div class="col-lg-8 pt-4 pt-lg-0 content" data-aos="fade-left">
                    <h3>Junior Front End WebDeveloper</h3>

                    <div class="row mt-5">
                        <div class="col-lg-6 aboutMe">
                            <ul>
                                <li><i class="fas fa-birthday-cake" style={{ marginRight: '10px' }}></i> <strong>Birthday : </strong> 1st Feb 1994</li>
                                <li><i class="fas fa-phone-alt" style={{ marginRight: '10px' }}></i> <strong>Phone : </strong> +19293285859</li>
                                <li><i class="fas fa-city" style={{ marginRight: '10px' }}></i> <strong>City : </strong>New York, USA</li>
                            </ul>
                        </div>
                        <div class="col-lg-6 aboutMe">
                            <ul>

                                <li><i class="icofont-rounded-right"></i> <strong>Email:</strong> eshshatabdi@gmail.com</li>
                            </ul>
                        </div>
                    </div>
                    <p className="mt-5 ">
                        Looking to establish my career in the field of software engineering with an opportunity to improve my skills and strengths in conjunction with the organizational goals and to attain excellence through experience.
                    </p>
                </div>
            </div>


        </div>
    );
};

export default AboutMe;